import { SET_MODAL, CLOSE_MODAL, MINIMIZE_MODAL, MAXIMIZE_MODAL } from './GLobalModalTypes.js'

const initialState = { modals: {} }

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_MODAL:
      return {
        ...state,
        modals: { ...state.modals, [action.payload.id]: action.payload },
      }
    case CLOSE_MODAL:
      const oldModals = state.modals
      delete oldModals[action.payload]
      return {
        ...state,
        modals: { ...oldModals },
      }

    case MINIMIZE_MODAL:
      return {
        ...state,
        modals: {
          ...state.modals,
          [action.payload]: {
            ...state.modals[action.payload],
            type: 'minimized',
          },
        },
      }
    case MAXIMIZE_MODAL:
      return {
        ...state,
        modals: {
          ...state.modals,
          [action.payload]: {
            ...state.modals[action.payload],
            type: 'maximized',
          },
        },
      }
    default:
      return state
  }
}
